import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/base.css'

// 兼容旧 Hash 链接：/#/legal/... → /legal/...
const hashPath = window.location.hash
if (hashPath.startsWith('#/')) {
  const target = hashPath.slice(1) + window.location.search
  window.history.replaceState(null, '', target)
}

createApp(App).use(store).use(router).mount('#app')
